import React, { useCallback, useMemo } from 'react';
import css from './styles.module.scss';
import { Typography, Switch } from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';
import { selectNewSong } from '~/features/dashboard/store/selectors';
import { StepControls } from '~/common/step-controls';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { createNewSongStepOneThunk } from '~/features/dashboard/store/actions.thunks';
import { useRouteMatch } from 'react-router-dom';
import { INewSongStepOneFormInputs } from '~/models/music/new-song/formInputs';
import { NamedForm } from '~/features/dashboard/components/add-song/components/named-form';

interface Step_1Props {}

export const Step_1: React.FC<Step_1Props> = () => {
    const match = useRouteMatch<{ creatorId: string }>();
    const creatorId = useMemo(() => Number(match.params.creatorId), [match.params.creatorId]);
    const newSongState = useSelector(selectNewSong);
    const dispatch = useThunkDispatch();

    const {
        handleSubmit,
        register,
        errors,
        setValue,
        control,
        formState: { isDirty, isSubmitting },
    } = useForm<INewSongStepOneFormInputs>({
        defaultValues: {
            songName: newSongState?.gSongName || '',
            isPubEligible: Boolean(newSongState?.isPubEligible) || false,
            isRecEligible: Boolean(newSongState?.isRecEligible) || false,
            isNBREligible: Boolean(newSongState?.isNBREligible) || false,
            isOtherEligible: Boolean(newSongState?.isOtherEligible) || false,
            isWriterShareEligible: Boolean(newSongState?.isWriterShareEligible) || false,
        },
    });

    const onSubmit = useCallback(
        (data: INewSongStepOneFormInputs) => {
            dispatch(createNewSongStepOneThunk({ ...data, creatorId, isDirty }));
        },
        [creatorId, dispatch, isDirty]
    );

    return (
        <NamedForm name={newSongState?.gSongName} onSubmit={handleSubmit(onSubmit)}>
            <Typography variant={'h4'} className={css.songtitle}>
                What is your Song’s name?
            </Typography>
            <Typography className={css.descText}>We will check if it exists</Typography>
            <TextField
                className={css.input}
                variant="filled"
                fullWidth
                // placeholder="Write a name"
                autoFocus
                name={'songName'}
                inputRef={register({ required: 'Song name is required' })}
                error={!!errors.songName}
                helperText={errors.songName ? errors.songName.message : ''}
            />
            <Typography variant={'h6'} className="publish-title">
                What rights do you have for this Song?
            </Typography>
            <div className="inputcustom-main-outer1">
                <div className="inputcustom-outer switch-custom-outer" style={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}>
                    <label className="customlabel">Publishing</label>
                    <span>No</span>
                    <Controller
                        name="isPubEligible"
                        control={control}
                        render={props => {
                            return (
                                <Switch
                                    // size="small"
                                    id="e-book-switch"
                                    type="checkbox"
                                    name="isPubEligible"
                                    onChange={e => setValue('isPubEligible', e.target.checked)}
                                    // inputRef={register}
                                    value={props.value}
                                    checked={props.value}
                                />
                            );
                        }}
                    />
                    <span> Yes</span>
                </div>
                <div className="inputcustom-outer switch-custom-outer" style={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}>
                    <label className="customlabel">Masters</label>
                    <span>No</span>
                    <Controller
                        name="isRecEligible"
                        control={control}
                        render={props => {
                            return (
                                <Switch
                                    // size="small"
                                    id="e-book-switch1"
                                    type="checkbox"
                                    name="isRecEligible"
                                    onChange={e => setValue('isRecEligible', e.target.checked)}
                                    // inputRef={register}
                                    value={props.value}
                                    checked={props.value}
                                />
                            );
                        }}
                    />
                    <span> Yes</span>
                </div>
                <div className="inputcustom-outer switch-custom-outer" style={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}>
                    <label className="customlabel">Neighboring Rights</label>
                    <span>No</span>
                    <Controller
                        name="isNBREligible"
                        control={control}
                        render={props => {
                            return (
                                <Switch
                                    // size="small"
                                    id="e-book-switch2"
                                    type="checkbox"
                                    name="isNBREligible"
                                    onChange={e => setValue('isNBREligible', e.target.checked)}
                                    // inputRef={register}
                                    value={props.value}
                                    checked={props.value}
                                />
                            );
                        }}
                    />
                    <span>Yes</span>
                </div>
                <div className="inputcustom-outer switch-custom-outer" style={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}>
                    <label className="customlabel">Writer Share Eligible</label>
                    <span>No</span>
                    <Controller
                        name="isWriterShareEligible"
                        control={control}
                        render={props => {
                            return (
                                <Switch
                                    // size="small"
                                    id="e-book-switch2"
                                    type="checkbox"
                                    name="isWriterShareEligible"
                                    onChange={e => setValue('isWriterShareEligible', e.target.checked)}
                                    // inputRef={register}
                                    value={props.value}
                                    checked={props.value}
                                />
                            );
                        }}
                    />
                    <span>Yes</span>
                </div>
                <div className="inputcustom-outer switch-custom-outer" style={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}>
                    <label className="customlabel">Other</label>
                    <span>No</span>
                    <Controller
                        name="isOtherEligible"
                        control={control}
                        render={props => {
                            return (
                                <Switch
                                    // size="small"
                                    id="e-book-switch2"
                                    type="checkbox"
                                    name="isOtherEligible"
                                    onChange={e => setValue('isOtherEligible', e.target.checked)}
                                    // inputRef={register}
                                    value={props.value}
                                    checked={props.value}
                                />
                            );
                        }}
                    />
                    <span>Yes</span>
                </div>
            </div>

            <StepControls className={css.nextButton} isSubmitting={isSubmitting} />
        </NamedForm>
    );
};
